import { render, staticRenderFns } from "./SwordModal.vue?vue&type=template&id=044b8fc3&scoped=true&"
import script from "./SwordModal.vue?vue&type=script&lang=js&"
export * from "./SwordModal.vue?vue&type=script&lang=js&"
import style0 from "./SwordModal.vue?vue&type=style&index=0&id=044b8fc3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "044b8fc3",
  null
  
)

export default component.exports